import React from 'react';

import RegisterDetails from './RegisterDetails';
import RegisterAccount from './RegisterAccount';
import RegisterAccountInvite from './RegisterAccountInvite';

export const RegisterStep = ({
  step,
  onNext,
  onPrev,
  values,
  errors,
  errorSet,
  errorClear,
  onCardAdd,
  onRegister,
  invitation,
  accountInvite,
  invitationError,
  onCreateAccount,
  onInviteRegister
}) => {
  if (accountInvite) {
    switch (step) {
    case 0:
      return (
        <RegisterDetails 
          accountInvite
          values={values} 
          errors={errors}
          onSubmit={onNext} 
        />
      );
    case 1:
      return (
        <RegisterAccountInvite 
          values={values}
          errors={errors}
          onPrev={onPrev}
          invitation={invitation}
          onSubmit={onInviteRegister}
          onCreateAccount={onCreateAccount}
        />
      );
    default: return null;
    }
  } else {
    switch (step) {
      case 0:
        return (
          <RegisterDetails 
            values={values} 
            errors={errors}
            onSubmit={onNext}
          />
        );
      case 1:
        return (
          <RegisterAccount 
            onPrev={onPrev}
            values={values} 
            errors={errors}
            onSubmit={onRegister} 
            invitation={invitation}
            invitationError={invitationError}
            onCreateAccount={onCreateAccount}
          />
        );
      default: return null;
    }
  }
};

export default RegisterStep;
